import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import React, { useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { LoaderOverlay } from 'core-components/library/loader'
import { Controller, isEmpty, ValidateInput } from 'core-components/library/validation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { Title } from '../../styledComponents/title/Title'

import { updateVersionName } from './api/updateVersionName'

import styles from './UpdateVersionContent.module.scss'

interface IProps {
  selectedVersion: IELTData
  closeDialog: () => void
}

export const UpdateVersionContent = ({ selectedVersion, closeDialog }: IProps) => {
  const [versionName, setVersionName] = useState(selectedVersion.VersionName)
  const [wip, setWip] = useState(false)

  const onSave = async () => {
    setWip(true)
    await updateVersionName(selectedVersion, versionName)
    setWip(false)
    closeDialog()
  }

  return (
    <Controller>
      <div className={styles.root}>
        <LoaderOverlay show={wip} />
        <Title align={'center'} text={getFormedEltTranslation('update-version')} />
        <ValidateInput checkFn={isEmpty} value={versionName} onChange={setVersionName} />
        <div className={styles.btnWrapper}>
          <Button onClick={onSave} disabled={!versionName}>
            <Translation text={getFormedEltTranslation('save')} />
          </Button>
        </div>
      </div>
    </Controller>
  )
}
